import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

interface IButton {
  istransparent?: boolean;
}

const style = css<IButton>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: ${(props) => props.istransparent ? `1px solid ${props.theme.colors.brand1.pure}` : "none"};
  padding: 16px;
  border-radius: 8px;
  background-color: ${(props) => props.istransparent ? "transparent" : props.theme.colors.brand1.pure};
  color: ${(props) => props.istransparent ? props.theme.colors.brand1.pure : props.theme.colors.typography2.dark};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.9rem;
  box-sizing: border-box;
  width: 100%;
  
  :disabled {
    background-color: ${(props) => props.theme.colors.typography2.light};
    color: ${(props) => props.theme.colors.typography2.dark};
    cursor: not-allowed;
  }

  .svg__icon--button {
    width: 24px;
    height: 18px;
  }

  .button__modal {
    display: flex;
    align-items: center;
    justify-content: center;

    > span {
      height: 1.1rem;
      height: auto;
      font-weight: 600;
    }
  }

  @media screen and (min-width: 480px) {
    border-radius: 8px;
    justify-content: center;

    &.buttonwidth{
      width: 340px;
    }

    .svg__icon--button {
      width: 24px;
      height: 26px;    
    }

    .button__modal {
      > span {
          font-size: 1.5rem;
          line-height: 30px;
          margin: 0px 10px; 
      }
    }
  }

  @media (min-width: 768px) {
    padding: 16px;
    font-size: 0.9rem;
    height: 44px;

    .svg__icon--button {
      width: 13px;
      height: 15px;      
    }

    .button__modal {

    > span {
        font-size: 0.75rem;
        line-height: 15px;
        margin: 0px 8px;
      }
    }  
  }`;

export const Button = styled.button<IButton>`
  ${style}
`;

export const ButtonLink = styled(Link) <IButton>`
  ${style}
`;
